import { createAction } from '@reduxjs/toolkit'

export const addReferenceDataEntry = createAction(
  'referenceData/addReferenceDataEntry'
)

export const updateReferenceDataEntry = createAction(
  'referenceData/updateReferenceDataEntry'
)

export const deleteReferenceDataEntry = createAction(
  'referenceData/deleteReferenceDataEntry'
)

export const createReferenceDataEntry = ({
  guid,
  dependent_entry,
  reference_data_column,
  reference_data_id,
  label,
}) => {
  return addReferenceDataEntry({
    guid,
    dependent_entry,
    reference_data_column,
    reference_data_id,
    label,
  })
}
